import { EQUIPMENT_TYPE_KEY } from 'apps/marketplace/store/transfixLane/types'

export interface IEquipmentType {
  id: string
  key: EQUIPMENT_TYPE_KEY
}

export interface ITransfixLane {
  id: string
  pickupMarketId: string
  deliveryMarketId: string
  pickupCityState: string
  deliveryCityState: string
  laneKey: string
  equipment: IEquipmentType
}

export interface ISpecificLane {
  id: string
  pickupCityState: string
  deliveryCityState: string
  equipment: IEquipmentType
  isDropTrailer: boolean
  shipperApplication: IShipper
}

export interface ILaneMetric {
  transfixLane: ITransfixLane
  specificLane: ISpecificLane
  metrics: IMetrics
  avgRate: number
  avgMargin: number
  datMarketLaneId: string
  numTendered: number
  numAutoOffered: number
  numOnHold: number
  numInWaterfall: number
  numSpecificLanes: number
  numLaneAlertCarriers: number
  numReservedCarriers: number
  autoOfferedList?: number[]
  onHoldList?: number[]
  tenderedList?: number[]
  waterfallList?: number[]
  rfpLaneKey: string
  shipperName: string
  volume: number
  projectedVolume: number
}

export interface IMetrics {
  reservedAcceptance: number
  laneAlertAcceptance: number
  otp: number
  otd: number
  bounce: number
  tracking: number
}

export enum SORT_FIELDS {
  AVERAGE_RATE = 'avg_carrier_rate',
  AVERAGE_MARGIN = 'avg_margin',
  VOLUME = 'shipment_count',
  NUM_ON_HOLD = 'on_hold_count',
  NUM_IN_WATERFALL = 'reserved_count',
  NUM_IN_TENDERED = 'tendered_count',
  RESERVED_ACCEPTANCE = 'reserved_percent',
  LANE_ALERT = 'lane_alert_percent',
  OTP = 'otp',
  OTD = 'otd',
  BOUNCE = 'bounce_percent',
  TRACKING = 'avg_tracking_percent',
}

export interface ILaneMetricsState {
  data?: ILaneMetric[]
  loading: boolean
  error: string
  totalCount: number
  currentFilters: ILaneMetricsParams
}

export enum LoadType {
  drop = 'drop',
  live = 'live',
}

export interface ILaneMetricsParams {
  pageCount?: number
  perPage?: number
  sortField?: SORT_FIELDS
  sortOrder?: SORT_ORDER
  assignedToMe?: boolean
  myRates?: boolean
  myCarriers?: boolean
  pickupAttributes?: ILocation
  deliveryAttributes?: ILocation
  equipmentIds?: string[]
  pickupRegions?: string[]
  deliveryRegions?: string[]
  shipperApplicationId?: string
  carrierApplicationId?: string
  searchType?: string // This field is ignored by the API, and is used to populate the field in ILocation when the call is made
  userId?: string
  loadType?: LoadType
  carrierContractLaneId?: string // Contract lane ID for parent carrier * @example '3468995'
}

export enum SORT_ORDER {
  ASC = 'asc',
  DESC = 'desc',
}

export interface ILocation {
  id?: string
  city: string
  stateCode: string
  radius?: string
  searchType?: string
}

export interface IShipper {
  id: string
  name: string
}
